import styled from '@emotion/styled';
import React, { useRef, useEffect, useLayoutEffect } from 'react';
import { PharmacyCalendarDatePicker } from './PharmacyCalendarDatePicker';
import { OneLinePharmacyCalendarDatePickerProps } from './PharmacyCalendarDatePickersProps';
import { CalendarPerfMonitor } from '../CalendarPerfMonitor';

export const OneLinePharmacyCalendarDatePicker = ({
  onScroll,
  year,
  initialMonth,
  modifiers,
  onChange,
}: OneLinePharmacyCalendarDatePickerProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const renderStartRef = useRef(performance.now());
  renderStartRef.current = performance.now();

  // Fires after all 13 DayPicker children have committed — captures total DayPicker render cost.
  useLayoutEffect(() => {
    CalendarPerfMonitor.accumulate('[One] actual render', performance.now() - renderStartRef.current);
  });

  const months = CalendarPerfMonitor.measure('[One] buildMonths(13)', () => {
    const result: JSX.Element[] = [];
    for (let i = initialMonth; i < initialMonth + 13; i++) {
      const maxDate = i >= 11 ? new Date(year + 1, i % 11) : new Date(year, i + 1);
      maxDate.setDate(maxDate.getDate() - 1);
      result.push(
        <span key={i - initialMonth}>
          <PharmacyCalendarDatePicker
            initialMonth={new Date(year, i)}
            minDate={new Date(year, i)}
            maxDate={maxDate}
            modifiers={modifiers}
            onChange={onChange}
          />
        </span>,
      );
    }
    return result;
  });

  useEffect(() => {
    if (scrollRef.current) {
      const scrollLeftString = sessionStorage.getItem('scrollingCalendarScrollPositionLeft');
      const scrollLeft = scrollLeftString !== null ? Number(scrollLeftString) : 0;

      scrollRef.current.scrollLeft = scrollLeft;
    }
  }, [onChange]);

  return (
    <DivScrollLine ref={scrollRef} onScroll={onScroll} className="scrollingCalendar">
      {months}
    </DivScrollLine>
  );
};

const DivScrollLine = styled.div`
  display: flex;
  flex-direction: row;
  width: 54%;
  overflow: auto;
`;
